import { Link } from "react-router-dom";
import { Check, Circle, ChevronRight, Sparkles } from "lucide-react";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";

interface Props {
  variant?: "card" | "inline";
  className?: string;
}

const SetupChecklist = ({ variant = "card", className = "" }: Props) => {
  const { loading, checklist, progress } = useOnboardingStatus();

  if (loading || checklist.length === 0) return null;
  if (progress >= 1) return null;

  const pct = Math.round(progress * 100);

  const wrapper =
    variant === "card"
      ? "bg-card border border-border rounded-2xl p-5 shadow-card"
      : "bg-primary/5 border border-primary/20 rounded-2xl p-5";

  return (
    <div className={`${wrapper} ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-primary" />
          <h3 className="font-display font-semibold text-sm">
            Get the most out of The Emerging Market
          </h3>
        </div>
        <span className="text-xs font-medium text-muted-foreground">
          {pct}% complete
        </span>
      </div>

      <div className="h-1.5 bg-muted rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-primary transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>

      <ul className="space-y-1">
        {checklist.map((item) => (
          <li key={item.id}>
            <Link
              to={item.href}
              className={`flex items-center justify-between gap-3 rounded-lg px-2 py-2 -mx-2 transition-colors ${
                item.done
                  ? "text-muted-foreground"
                  : "hover:bg-secondary/60"
              }`}
            >
              <div className="flex items-center gap-3 min-w-0">
                {item.done ? (
                  <Check className="h-4 w-4 text-primary shrink-0" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground shrink-0" />
                )}
                <span
                  className={`text-sm truncate ${item.done ? "line-through" : ""}`}
                >
                  {item.label}
                </span>
              </div>
              {!item.done && (
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SetupChecklist;